import React from 'react';
import PropTypes from 'prop-types';
import {Box, useMediaQuery, useTheme, Typography} from '@material-ui/core';
import {RadioButton} from "../../index";
import {t} from 'ttag';
import {SW_PASSENGER_TYPES} from "../../../store/types";

const PassengerTypeSelector = ({type, onChange, disabledTypes}) => {

    const {breakpoints} = useTheme();
    const isLowerThenMedium = useMediaQuery(breakpoints.down('md'));
    const isLowerThenSmall = useMediaQuery(breakpoints.down('xs'));

    return (
        <Box display={'flex'} flexDirection={isLowerThenMedium ? 'column' : 'row'}>
            <RadioButton
                label={<Typography variant={isLowerThenSmall ? 'caption' : undefined}>{t`Regular`}</Typography>}
                checked={type === SW_PASSENGER_TYPES.ADULT}
                onChange={() => onChange(SW_PASSENGER_TYPES.ADULT)}
                disabled={disabledTypes.includes(SW_PASSENGER_TYPES.ADULT)}
            />
            <RadioButton
                label={<Typography variant={isLowerThenSmall ? 'caption' : undefined}>{t`Resident in Azores`}</Typography>}
                checked={type === SW_PASSENGER_TYPES.RESIDENT}
                onChange={() => onChange(SW_PASSENGER_TYPES.RESIDENT)}
                disabled={disabledTypes.includes(SW_PASSENGER_TYPES.RESIDENT)}
            />
            <RadioButton
                label={<Typography variant={isLowerThenSmall ? 'caption' : undefined}>{t`Student (12-26 years old)`}</Typography>}
                checked={type === SW_PASSENGER_TYPES.STUDENT}
                onChange={() => onChange(SW_PASSENGER_TYPES.STUDENT)}
                disabled={disabledTypes.includes(SW_PASSENGER_TYPES.STUDENT)}
            />
        </Box>
    );
};

PassengerTypeSelector.PASSENGER_TYPES = SW_PASSENGER_TYPES;

PassengerTypeSelector.propTypes = {
    type: PropTypes.oneOf(Object.values(PassengerTypeSelector.PASSENGER_TYPES)),
    disabledTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.values(PassengerTypeSelector.PASSENGER_TYPES))),
    onChange: PropTypes.func,
};

PassengerTypeSelector.defaultProps = {
    type: null,
    disabledTypes: [],
    onChange: () => null,
};

export default PassengerTypeSelector;